module.exports = __webpack_public_path__ + "img/sort／web／Arcade@2x.18b4ce78.png";